import { useEffect, useState } from 'react';
import { SettingsBlock } from './SettingsBlock';
import { Segmented } from '../../components/Segmented';
import {
  APPEARANCE_EVENT,
  SCALES,
  applyScale,
  applyTheme,
  readScale,
  readTheme,
  watchSystem,
  type ThemeChoice,
} from '../../store/theme';

// Impostazioni › Generale: le stesse scelte del menu in alto (tema e dimensione), tenute allineate
// con l'evento di store/theme. Valgono per questo browser.
export function AppearanceTab() {
  const [choice, setChoice] = useState<ThemeChoice>(readTheme);
  const [scale, setScale] = useState(readScale);
  useEffect(() => {
    const sync = () => {
      setChoice(readTheme());
      setScale(readScale());
    };
    window.addEventListener(APPEARANCE_EVENT, sync);
    return () => window.removeEventListener(APPEARANCE_EVENT, sync);
  }, []);
  useEffect(() => watchSystem(choice, () => applyTheme(choice)), [choice]);

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <SettingsBlock
        over="Aspetto"
        title="Tema dell’interfaccia"
        hint="«Sistema» segue l’impostazione del dispositivo. Vale per questo browser."
        control={
          <Segmented
            label="Tema"
            value={choice}
            items={[
              { value: 'light', label: 'Chiaro' },
              { value: 'dark', label: 'Scuro' },
              { value: 'system', label: 'Sistema' },
            ]}
            onChange={applyTheme}
          />
        }
      />
      <SettingsBlock
        over="Aspetto"
        title="Dimensione dell’interfaccia"
        hint="Più piccola su uno schermo grande, più grande su uno piccolo."
        control={
          <Segmented
            label="Dimensione dell’interfaccia"
            value={String(scale)}
            items={SCALES.map((v) => ({ value: String(v), label: `${Math.round(v * 100)}%` }))}
            onChange={(v) => applyScale(Number(v))}
          />
        }
      />
    </div>
  );
}
